<template>
<Admin style="background: #f2f2f2;">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text v-if="!selectedCompany.isDemo">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <v-row align="center" justify="center" class="tw-mx-2">
              <v-col cols="12" class="tw-pt-1">
                <companies-management></companies-management>
              </v-col>
            </v-row>
          </v-card-text>
          <div v-else class="align-center justify-center" style="height: 200px; display: flex;">
            No Permission
          </div>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '../../components/admin/admin-main-template'
import CompaniesManagement from "../../components/admin/settings/companies-management";
import {mapState} from "vuex";

export default {
  name: 'SettingsCompany',
  components: {
    Admin,
    CompaniesManagement
  },
  computed: mapState({
    selectedCompany: state => state.companies.selectedCompany,
  }),
  data: () => ({
    items: [
      {
        text: 'ตั้งค่า',
        disabled: false,
        to: {name: 'Company.Settings'},
      },
      {
        text: 'โปรไฟล์บริษัท',
        disabled: true,
      },
    ],
  }),
}
</script>

<style lang="scss">
.row-wrapper{
  padding-left: 20px;
}
</style>
